import { takeLatest, put, call } from 'redux-saga/effects';

import { findPragaDoenca } from '../service';
import {
  FIND_PRAGA_DOENCA,
  FIND_PRAGA_DOENCA_PENDING,
  FIND_PRAGA_DOENCA_SUCCESS,
  FIND_PRAGA_DOENCA_FAILURE
} from '../actionTypes';

function* sagaFindPragaDoenca(action) {
  yield put({ type: FIND_PRAGA_DOENCA_PENDING })

  try {
    const registro = yield call(findPragaDoenca, action.id)
    yield put({ type: FIND_PRAGA_DOENCA_SUCCESS, registro: registro })

  } catch (error) {

    yield put({ type: FIND_PRAGA_DOENCA_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindPragaDoenca() {
  yield takeLatest(FIND_PRAGA_DOENCA, sagaFindPragaDoenca)
}